import { createAction, props } from '@ngrx/store';

export const set = createAction('[Module] set', props<{ payload: string }>());
export const setSubmodule = createAction('[Module] set submodule', props<{ payload: string }>());
